export default __webpack_public_path__ + "static/media/plus_circle.cfa86ce4.svg";